module.exports = __webpack_public_path__ + "img/transfer_money.4baf0e26.svg";